import {
	UnitSettingActions,
	Us1_01UnitSettingSelectors,
	useAppDispatch,
	useAppSelector,
} from '@/stores';
import { useEffect, useState } from 'react';

export const useLogic = () => {
	const dispatch = useAppDispatch();
	const [initialize, setInitialize] = useState<boolean>(true);
	useEffect(() => {
		dispatch(
			UnitSettingActions.getUnitSettingRequest({
				callback: () => {
					setInitialize(false);
				},
			})
		);
	}, []);
	const selectUnitSettingMasterInfo = useAppSelector(
		Us1_01UnitSettingSelectors.selectUnitSettingMasterInfo
	);

	return {
		loading: initialize,
		selectUnitSettingMasterInfo,
	};
};
